import React from 'react'

export const IconCircleStrikethrough = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.75 9C1.75 4.99594 4.99594 1.75 9 1.75C10.7319 1.75 12.322 2.35727 13.5689 3.3705L3.3705 13.5689C2.35727 12.322 1.75 10.7319 1.75 9ZM2.80515 15.1795C2.80767 15.1821 2.81021 15.1847 2.81278 15.1872C2.81535 15.1898 2.81793 15.1924 2.82052 15.1949C4.40335 16.7738 6.58767 17.75 9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 6.5864 16.7728 4.40104 15.1924 2.81801C15.1907 2.81627 15.1889 2.81454 15.1872 2.81281C15.1855 2.81107 15.1837 2.80934 15.182 2.80763C13.599 1.22724 11.4136 0.25 9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 11.4123 1.22622 13.5967 2.80515 15.1795ZM14.6295 4.43116C15.6427 5.67806 16.25 7.26812 16.25 9C16.25 13.0041 13.0041 16.25 9 16.25C7.26812 16.25 5.67806 15.6427 4.43116 14.6295L14.6295 4.43116Z"
      fill="currentColor"
    />
  </svg>
)
